<template>
  <section class="container">
    <div class="card">
      <transition :duration="400" name="component-fade" mode="out-in">
        <div v-if="!showThankYou" key="rc-title">
          <div class="card-image recovery-image" />
          <div class="card-title">Here’s your Recovery Code</div>
          <div class="card-content">
            <p>In the event that you need to login without your device you’ll need a recovery code; the recovery code is suitable for single use only, after the use it will be provided you a new one. Take a note and keep this somewhere safe:</p>
            <div class="recovery-area">{{ recoveryCode }}</div>
            <button class="download-recovery" v-on:click="onDownloadRecovery">
              DOWNLOAD CODE <div class="download-icon"></div>
            </button>
            <label class="my-checkbox">
              <input type="checkbox" name="saved_recovery" v-model.lazy="$v.savedRecovery.$model" />
              <span
                class="custom-checkbox"
                v-bind:class="{ error: $v.savedRecovery.$error && $v.savedRecovery.$dirty }"
              ></span>
              <span>I have safely recorded this code</span>
            </label>
            <div class="form-label">
              <div
                class="error-message"
                v-if="!$v.savedRecovery.sameAs && $v.savedRecovery.$dirty"
              >Please confirm you recorded the code.</div>
            </div>
          </div>
          <div class="card-actions">
            <button class="store-button" v-on:click="onSavedStep">Next</button>
          </div>
        </div>
        <div v-else key="ty-title">
          <div class="card-image ty-image" />
          <div class="card-title">Great, you are all set</div>
          <div class="card-content">
            <p>The 2-Step Verification via Authenticator app is now activated, in the future when logging in you’ll want your device handy.</p>
          </div>
          <div class="card-actions">
            <button class="store-button" v-on:click="onThankYouButtonClick">Got it</button>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import { sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'ShowRecoveryCode',
  props: ['recoveryCode', 'signature', 'state'],
  data() {
    return {
      showThankYou: false,
      savedRecovery: null
    };
  },
  validations: {
    savedRecovery: {
      sameAs: sameAs(() => true)
    }
  },
  methods: {
    onSavedStep() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.showThankYou = true;
      }
    },
    onThankYouButtonClick() {
      if (this.state) {
        window.location.replace(`https://${process.env.VUE_APP_AUTH0_DOMAIN}/continue?state=${this.state}`);
      } else {
        window.location.replace(process.env.VUE_APP_ID_PROFILE_URL);
      }
    },
    onDownloadRecovery() {
      const element = document.createElement('a');
      element.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' +
          encodeURIComponent(`Keep this backup code somewhere safe but accessible:\n${this.recoveryCode}`)
      );
      element.setAttribute('download', 'Arduino 2 step verification recovery code');

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  }
};
</script>

<style lang="scss">
.card-image {
  &.recovery-image {
    background-image: url("../assets/show-recovery.svg");
  }
  &.ty-image {
    background-image: url("../assets/ty.svg");
  }
}

.recovery-area {
  font-size: 26px;
  letter-spacing: 0.52px;
  line-height: 1.2;
  color: $teal3;
  background-color: $fog;
  padding: 10px 0;
  margin: 40px 0 20px;
  text-align: center;
}

.download-recovery {
  align-items: center;
  background: none !important;
  border: none;
  color: $teal3;
  cursor: pointer;
  display: flex;
  font-family: $typonine-sans-regular;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.64px;
  margin: 0 0 20px !important;
  outline: none;
  padding: 0 !important;
  text-transform: uppercase;

  .download-icon {
    background-image: url("../assets/download-icon.svg");
    height: 16px;
    margin-left: 8px;
    width: 16px;
  }
}
</style>
